import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

const notConfiguredError = {
  message: 'Supabase is not configured. Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to .env to enable data features.',
};

const demoUser = {
  id: 'local-demo-user',
  email: 'demo@studio.com',
  user_metadata: {
    full_name: 'Demo User',
  },
};

const demoProfile = {
  id: demoUser.id,
  email: demoUser.email,
  full_name: 'Demo User',
  role: 'premium',
  subscription_status: 'active',
  subscription_expires_at: null,
  demos_used: 0,
};

const createMockQuery = () => {
  const query = {
    select: () => query,
    insert: () => query,
    update: () => query,
    delete: () => query,
    eq: () => query,
    neq: () => query,
    order: () => query,
    limit: () => query,
    single: async () => ({ data: demoProfile, error: null }),
    maybeSingle: async () => ({ data: demoProfile, error: null }),
    then: (resolve) => resolve({ data: [], error: null }),
  };

  return query;
};

const createMockSupabase = () => ({
  auth: {
    getSession: async () => ({ data: { session: { user: demoUser } }, error: null }),
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
    signInWithPassword: async () => ({ data: { user: demoUser, session: { user: demoUser } }, error: null }),
    signUp: async () => ({ data: { user: demoUser, session: { user: demoUser } }, error: null }),
    signOut: async () => ({ error: null }),
  },
  from: () => createMockQuery(),
  rpc: async () => ({ data: null, error: null }),
  functions: {
    invoke: async () => ({ data: { isActive: true }, error: null }),
  },
  storage: {
    from: () => ({
      upload: async () => ({ data: null, error: notConfiguredError }),
      getPublicUrl: () => ({ data: { publicUrl: '' } }),
    }),
  },
});

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
      },
    })
  : createMockSupabase();
